




























































































































































































import axios from "axios";
import Vue from "vue";
import difference from "lodash.difference";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { common_state } from "./data/common.state";
import { ref, onMounted, Ref, computed } from "@vue/composition-api";
import AppCheckbox from "@/components/AppCheckbox.vue";
import { MipLabel, MipLabelOverride, MipBaseLabelOverride } from "./data/model";
import { isNotEmpty } from "@/fp";
import AppToggleBtn from "@/components/AppToggleBtn.vue";
import { UseActionToggle } from "@/common/composition/use-toggle";

interface UIMipItem extends MipLabel {
  check: boolean;
}

interface UIMipGroup {
  is_open: boolean;
  items: UIMipItem[];
}

export default Vue.extend({
  components: { Modal, AppCheckbox, AppToggleBtn },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      width: "36rem",
      height: "45rem",
      blank: true,
    };

    const is_loading = ref(true);
    const overwrite_for_all = ref(false);
    const initial_overwrite_for_all_state = ref(false);
    const groups: Ref<UIMipGroup[]> = ref([]);
    const initial_check_state: Ref<Record<string, boolean>> = ref({});

    const getLabelOverrides = async (
      label_id: string
    ): Promise<MipLabelOverride[]> => {
      async function get_overrides(
        all_items: MipLabelOverride[],
        last_cursor: string
      ): Promise<MipLabelOverride[]> {
        const res = await axios.get(
          `/extproxy/integrations/label-overrides?inEffect=true&labelId=${label_id}&cursor=${last_cursor}`
        );
        const { labelOverrides, cursor } = res.data.value;
        if (labelOverrides.length > 0) {
          all_items = all_items.concat(labelOverrides);
          if (cursor) {
            return await get_overrides(all_items, cursor);
          } else {
            return all_items;
          }
        } else {
          return all_items;
        }
      }
      const items = await get_overrides([], "");
      return items;
    };

    const calc_check_state = (
      groups_arr: UIMipGroup[]
    ): Record<string, boolean> => {
      return groups_arr
        .map((l) => l.items)
        .flat()
        .reduce((acc, item) => {
          acc[item.labelId] = item.check;
          return acc;
        }, {} as Record<string, boolean>);
    };

    onMounted(async () => {
      // @ts-ignore
      const cognni_label_id: string = props.modalData.label_id;
      // check if in label-configs this label is set to override:true
      // if so make the override all checked.
      overwrite_for_all.value = common_state.get_is_label_global_override(
        cognni_label_id
      );
      initial_overwrite_for_all_state.value = overwrite_for_all.value;

      const overrides = await getLabelOverrides(cognni_label_id);
      console.log("overrides : ", overrides);
      const tree = common_state.state.mipLabelsTree;

      groups.value = tree.reduce((acc, items) => {
        acc.push({
          is_open: true,
          // @ts-ignore
          items: items.map((item) => {
            const overrided = overrides.find(
              // @ts-ignore
              (l) => l.externalLabelId === item.labelId
            );
            return {
              ...item,
              // @ts-ignore
              disable: item.labelId === props.modalData.mip_label_id,
              // @ts-ignore
              check: isNotEmpty(overrided) && overrided.override,
            };
          }),
        });
        return acc;
      }, [] as UIMipGroup[]);

      initial_check_state.value = calc_check_state(groups.value);

      is_loading.value = false;
    });

    const on_check_change = (
      group: { items: any[] },
      item_id: string,
      index: number
    ) => {
      if (index === 0) {
        const val = !group.items[0].check;
        console.log(group, item_id, index, val);
        group.items.map((item) => {
          item.check = val;
          return item;
        });
      } else {
        group.items.map((item) => {
          if (item.labelId === item_id) {
            item.check = !item.check;
          }
          return item;
        });
      }
    };

    const get_checked_and_uncheked_ids = (obj: Record<string, boolean>) => {
      return Object.entries(obj).reduce(
        (acc, [key, val]) => {
          acc[val ? 0 : 1].push(key);
          return acc;
        },
        [[], []] as [string[], string[]]
      );
    };

    const { toggle, turn_off } = UseActionToggle(false, (is_on: boolean) => {
      groups.value = groups.value.map((sub) => {
        sub.items.map((item) => {
          item.check = is_on;
          return item;
        });
        return sub;
      });
    });

    const changes = computed(() => {
      const current_state = calc_check_state(groups.value);
      const [before_checked, before_unchecked] = get_checked_and_uncheked_ids(
        initial_check_state.value
      );

      const [after_checked, after_unchecked] = get_checked_and_uncheked_ids(
        current_state
      );

      const newly_checked_ids = difference(after_checked, before_checked);
      const newly_unchecked_ids = difference(after_unchecked, before_unchecked);
      return [newly_checked_ids, newly_unchecked_ids];
    });

    const update_override_all_status = async (override: boolean) => {
      overwrite_for_all.value = override;
      if (!overwrite_for_all.value) {
        turn_off();
      }
    };

    const has_changes = computed(() =>
      changes.value.some((arr) => arr.length > 0)
    );

    const does_overwrite_all_state_changed = computed(
      () => overwrite_for_all.value != initial_overwrite_for_all_state.value
    );

    const disable_apply = computed(() => {
      return !has_changes.value && !does_overwrite_all_state_changed.value;
    });

    /**
     * The overrides as the modal leaves them — override everything, or the
     * checked labels and not the unchecked ones — with what changed, for a
     * caller that writes changes rather than the whole picture.
     */
    const apply = async () => {
      const items = groups.value.map((l) => l.items).flat(1);
      const full = overwrite_for_all.value;
      const yes = full
        ? items.map((l) => l.labelId)
        : items.filter((d) => d.check).map((l) => l.labelId);
      const no = full ? [] : items.filter((d) => !d.check).map((l) => l.labelId);
      const [newly_checked_ids, newly_unchecked_ids] = changes.value;
      // @ts-ignore
      await props.modalData.save({
        full,
        full_changed: does_overwrite_all_state_changed.value,
        yes,
        no,
        newly_checked: newly_checked_ids,
        newly_unchecked: newly_unchecked_ids,
      });
      emit("submit", yes);
    };

    const are_all_checked = computed(() => {
      // @ts-ignore
      const mip_label_id: string = props.modalData.mip_label_id;
      return groups.value.every((sub) =>
        sub.items
          .filter((l) => l.labelId !== mip_label_id)
          .every((item) => item.check)
      );
    });

    return {
      disable_apply,
      config,
      changes,
      groups,
      overwrite_for_all,
      initial_overwrite_for_all_state,
      on_check_change,
      apply,
      initial_check_state,
      are_all_checked,
      toggle_check_all: toggle,
      update_override_all_status,
    };
  },
});
